
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7WjUL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $e4o8D = parcelRequire("e4o8D");


var $bQm3c = parcelRequire("bQm3c");





var $ez9xU = parcelRequire("ez9xU");

/**
 * Analytics-attribution tag for opens triggered by the Confluence deep link.
 * A local string (not added to the platform `RovoSettingsModalSurface` enum,
 * which is for surfaces with an active experiment); a non-`search-*` surface
 * already defaults the discovery tab on.
 */ const $bde2a39acd550407$var$CONNECTOR_DEEP_LINK_SURFACE = 'confluence-deep-link';
/**
 * Opens the modal once when `isActive` becomes true, then re-arms when it goes
 * false (e.g. after the URL is cleaned up) so a later re-appearance opens again.
 *
 * Receives the modal's stable `open` as a prop and calls it from an effect — the
 * open trigger and the ref guard live in the commit phase, never during render.
 */ const $bde2a39acd550407$var$OpenOnActive = ({ open: open, isActive: isActive, onHandled: onHandled })=>{
    const openedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isActive) {
            if (!openedRef.current) {
                openedRef.current = true;
                open({
                    defaultTab: 'discovery'
                });
                onHandled();
            }
        } else openedRef.current = false;
    }, [
        isActive,
        open,
        onHandled
    ]);
    return null;
};
const $bde2a39acd550407$export$244bb8141909b27b = ({ cloudId: cloudId, isActive: isActive, onHandled: onHandled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ez9xU.RovoSettingsModal), {
        product: "confluence",
        cloudId: cloudId,
        surface: $bde2a39acd550407$var$CONNECTOR_DEEP_LINK_SURFACE
    }, ({ open: open })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bde2a39acd550407$var$OpenOnActive, {
            open: open,
            isActive: isActive,
            onHandled: onHandled
        }));






var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");

const $26bd1ca50d63a453$var$ADD_CONNECTOR_PARAM = 'add-connector';
const $26bd1ca50d63a453$var$SOURCE_PARAM = 'source';
/**
 * Embed/standalone routes where the deep link must never act, even if the param
 * is present. Admin needs no entry here: admin routes are not part of the SPA
 * `routeComponents`, so `GlobalComponents` (and therefore this hook) never
 * renders on them.
 */ const $26bd1ca50d63a453$var$EXCLUDED_ROUTE_NAMES = new Set([
    (0, $1NBp8.EDIT_PAGE_EMBED).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EMBEDDED_MULTIPLE_SUBCALENDAR).name,
    (0, $1NBp8.SPACE_EMBEDDED_SUBCALENDAR).name
]);
const $26bd1ca50d63a453$export$bab0da7564a2aae5 = ()=>{
    const { match: match, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const query = match?.query ?? {};
    const isExcludedRoute = match?.name ? $26bd1ca50d63a453$var$EXCLUDED_ROUTE_NAMES.has(match.name) : false;
    const isDeepLinkActive = $26bd1ca50d63a453$var$ADD_CONNECTOR_PARAM in query && !isExcludedRoute;
    const markHandled = (0, $cozmU.useCallback)(()=>{
        // `setQueryParams` merges then deletes null/undefined keys, so this removes
        // our params and is a no-op for any that aren't present.
        setQueryParams({
            [$26bd1ca50d63a453$var$ADD_CONNECTOR_PARAM]: undefined,
            [$26bd1ca50d63a453$var$SOURCE_PARAM]: undefined
        }, true);
    }, [
        setQueryParams
    ]);
    return {
        isDeepLinkActive: isDeepLinkActive,
        markHandled: markHandled
    };
};


const $ae5162257a940ecc$export$ac11f5dd0a537404 = ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [everActive, setEverActive] = (0, $cozmU.useState)(false);
    const { isDeepLinkActive: isDeepLinkActive, markHandled: markHandled } = (0, $26bd1ca50d63a453$export$bab0da7564a2aae5)();
    // Default to {} so we no-op rather than throw if rendered without a
    // SessionDataContext provider (e.g. in isolation tests).
    const { cloudId: cloudId, isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)() ?? {};
    (0, $cozmU.useEffect)(()=>{
        if (isDeepLinkActive) setEverActive(true);
    }, [
        isDeepLinkActive
    ]);
    if (renderServerPlaceholder || !everActive || !isRovoEnabled || !cloudId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bde2a39acd550407$export$244bb8141909b27b), {
        cloudId: cloudId,
        isActive: isDeepLinkActive,
        onHandled: markHandled
    });
};
module.exports["ConnectorDeepLink"] = $ae5162257a940ecc$export$ac11f5dd0a537404;

});

parcelRegister("ez9xU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $jmUhx = parcelRequire("jmUhx");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");


var $eytcg = parcelRequire("eytcg");

const $c25508467e1a19ee$var$triggerStyles = {
    button: "_1dqoglyw _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _bfhk1j28 _80omtlke _1bsb1osq _irr31dpa",
    text: "_11c8wadc _syaz1rpy"
};
const $c25508467e1a19ee$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $c25508467e1a19ee$var$triggerStyles.button,
        onClick: ()=>open()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c25508467e1a19ee$var$triggerStyles.text
    }, formatMessage((0, $eytcg.messages).defaultTriggerLabel))));
};

const $c25508467e1a19ee$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("1EL9F")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        }))); /**
       * Self-contained entrypoint for the Rovo Settings modal.
       *
       * The trigger renders eagerly. The provider tree and modal
       * are lazy-loaded only when the user first clicks the trigger.
       * Subsequent opens reuse the mounted provider — no re-mount or re-fetch.
       */ 
const $c25508467e1a19ee$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $cozmU.useState)(false);
    const pendingOpenOptions = (0, $cozmU.useRef)(undefined);
    const openModalRef = (0, $cozmU.useRef)(null);
    const open = (0, $cozmU.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []); // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>null
    }, triggerNode, isActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$LazyRovoSettingsModalProvider, {
        ...providerProps,
        pendingOpenOptions: pendingOpenOptions,
        openModalRef: openModalRef
    })));
};
module.exports["RovoSettingsModal"] = $c25508467e1a19ee$export$f2c3f3e62df426ba;

});

parcelRegister("eytcg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2c6792bc438bfd46$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final",
        defaultMessage: "Sources & apps"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final",
        defaultMessage: "Search settings"
    },
    defaultTriggerLabel: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final",
        defaultMessage: "Explore all apps"
    }
});
module.exports["messages"] = $2c6792bc438bfd46$export$defe85febe8b728c;

});

parcelRegister("1EL9F", function(module, exports) {

let $134e1ad6fb1d7fc3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $134e1ad6fb1d7fc3$var$load("kT6dz"),
    $134e1ad6fb1d7fc3$var$load("jZMUd"),
    $134e1ad6fb1d7fc3$var$load("6wr18"),
    $134e1ad6fb1d7fc3$var$load("eFxOr"),
    $134e1ad6fb1d7fc3$var$load("7EorR"),
    $134e1ad6fb1d7fc3$var$load("ffEVr"),
    $134e1ad6fb1d7fc3$var$load("kxBJV"),
    $134e1ad6fb1d7fc3$var$load("iH9Sz"),
    $134e1ad6fb1d7fc3$var$load("dq8fV"),
    $134e1ad6fb1d7fc3$var$load("jUskc"),
    $134e1ad6fb1d7fc3$var$load("iDvaG"),
    $134e1ad6fb1d7fc3$var$load("cY820"),
    $134e1ad6fb1d7fc3$var$load("hhss7"),
    $134e1ad6fb1d7fc3$var$load("Wowvf"),
    $134e1ad6fb1d7fc3$var$load("2l8zo"),
    $134e1ad6fb1d7fc3$var$load("iDKFy"),
    $134e1ad6fb1d7fc3$var$load("gerr7"),
    $134e1ad6fb1d7fc3$var$load("cKDij")
]).then(()=>parcelRequire('7bLo5'));

});


//# sourceMappingURL=ConnectorDeepLink.190f5b3f.js.map
